<template>
  <section-page
    title="Deactivated Users"
    is-short
  >
    <p
      v-if="showUpgradeMessage"
      class="upgrade_message"
    >
      <strong>UPGRADE REQUIRED:</strong> You've reached your limit on users. Please <a
      @click="openBillingPortal">upgrade</a> your subscription in order to reactivate any users.
    </p>

    <app-loading-section
      :loading="false"
      :count="inactiveUsers.length"
      heading="There are no inactive users"
    >
      <table-default
        :table-data="inactiveUsers"
        default-sort="full_name"
      >
        <b-table-column label="Name" field="full_name" sortable v-slot="props">
          {{ props.row.full_name }}
        </b-table-column>

        <b-table-column label="Email Address" field="email_address" sortable v-slot="props">
          {{ props.row.email_address }}
        </b-table-column>

        <b-table-column label="Added On" field="created_at" sortable v-slot="props">
          {{ formatDate(props.row.created_at) }}
        </b-table-column>

        <b-table-column label="Deactivated On" field="deleted_at" sortable v-slot="props">
          {{ formatDate(props.row.deleted_at) }}
        </b-table-column>

        <b-table-column cell-class="action_cell" width="200" v-slot="props">
          <button-link
            :loading="isRestoring"
            :disabled="showUpgradeMessage"
            @click="reactivate(props.row.id)"
          >Reactivate
          </button-link>
        </b-table-column>
      </table-default>
    </app-loading-section>
  </section-page>
</template>

<script>
import dates from "../../../services/dates";

export default {
  name: "UsersDeactivatedUsers",
  props: {
    invitedUserCount: {
      type: Number,
      required: true
    },
  },
  data() {
    return {
      isRestoring: false
    }
  },
  computed: {
    inactiveUsers() {
      return this.$store.getters.users.filter(u => u.deleted_at);
    },
    userCount() {
      return this.$store.getters.activeUsers.length + this.invitedUserCount;
    },
    userLimit() {
      return this.$store.getters.account.user_limit;
    },
    showUpgradeMessage() {
      if (this.inactiveUsers.length === 0) return false;
      return this.userCount >= this.userLimit;
    },
  },
  methods: {
    formatDate(timestamp) {
      return dates.formatAsDateTime(timestamp);
    },
    reactivate(userId) {
      if (this.hasNoAvailableUsers) return false;

      this.isRestoring = true;

      this.$api.users.restore(userId)
        .then(() => {
          this.$buefy.toast.open({
            message: "User has been reactivated",
            type: 'is-success'
          });
        })
        .finally(() => this.isRestoring = false);
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.upgrade_message {
  margin-bottom: 6px;
  font-size: 0.875rem;
  line-height: 1.3;

  strong {
    color: $danger;
  }
}
</style>
